import { useEffect, useState, createRef, useCallback } from "react";
import {
  getTradePaginationList,
  getSearchTrade,
} from "../../services/news/news.service";
import TradeBar from "../../components/TradeBar/TradeBar";
import BreadCrumb from "../../components/breadcrumb/breadcrumb";
import Heading from "../../components/heading/heading";
import { getAttachmentsList } from "../../services/about/about.service";
import styles from "./Trade.module.css";

const SearchRef = createRef();

const NewsList = () => {
  let [query, setQuery] = useState(null);
  let [news, setNews] = useState([]);
  let [attachments, setAttachments] = useState([]);
  let [page, setPage] = useState(1);
  let [breadCrumbItems, setBreadCrumbItems] = useState([]);
  let [hasNextPage, setHasNextPage] = useState(false);
  let [nextPageLoading, setNextPageLoading] = useState(false);
  const getNextPage = () => {
    const currentPage = news[news.length - 1].id;
    setPage(currentPage);
    setNextPageLoading(true);
  };
  const cleanSearch = () => {
    SearchRef.current.value = "";
    setPage(1);
    setQuery(null);
    setNews([]);
  };
  const search = () => {
    const q = SearchRef.current.value;
    setQuery(q);
    setPage(1);
    setNews([]);
    setHasNextPage(false);
  };

  const fetchData = useCallback(() => {
    if (query === null) {
      getTradePaginationList(page - 1).then(({ data }) => {
        setNextPageLoading(false);
        if (data && data.data) {
          setNews((n) => [...n].concat([...data.data]));
        }

        if (data && data.data && data.data.length % 15 === 0) {
          setHasNextPage(true);
        } else {
          setHasNextPage(false);
        }
      });
    } else {
      getSearchTrade(page - 1, query).then(({ data }) => {
        setNextPageLoading(false);
        if (data && data.data) {
          setNews((n) => [...n].concat([...data.data]));
        }

        if (data && data.data && data.data.length % 15 === 0) {
          setHasNextPage(true);
        } else {
          setHasNextPage(false);
        }
      });
    }
  }, [page, query]);
  useEffect(() => {
    fetchData();
  }, [fetchData]);
  useEffect(() => {
    getAttachmentsList().then(({ data }) => {
      setAttachments((data && data.data) || []);
    });
    setBreadCrumbItems([
      { title: "خانه", url: "/" },
      { title: "مناقصه و مزایده", url: "/trade/list" },
    ]);
  }, []);
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      if (SearchRef.current.value.length > 2) {
        search();
      }
    }
  };
  return (
    <>
      <div className={"container"}>
        <div className={"row"}>
          <div className={"col-xs-12"}>
            <BreadCrumb items={breadCrumbItems} />
          </div>
          <div className={"clearfix"}></div>

          <div className={"col-xs-12"}>
            <div id={styles.searchWrapper}>
              <input
                type={"search"}
                ref={SearchRef}
                name="search"
                onKeyDown={handleKeyDown}
                id={styles.newsSearch}
                placeholder={"مناقصه خود را جستجو کنید ..."}
              />
              <i className={"fa fa-search"} onClick={search}></i>
              {query ? (
                <i className={"fa fa-trash"} onClick={cleanSearch}></i>
              ) : null}
            </div>
          </div>

          <div id={styles.newsListBox} className={"clearfix"}>
            <div className={"col-xs-12 col-md-9 pull-right"}>
              <div id={styles.newsListWrapper}>
                {news && news.length > 0 ? (
                  news.map((item, key) => {
                    return (
                      <div className="col-xs-12 col-md-6 pull-right">
                        <TradeBar key={key + "-product-bar"} product={item} />
                      </div>
                    );
                  })
                ) : (
                  <div className="loading-wrapper">
                    <img
                      src={"../../../assets/image/loading.svg"}
                      alt={"در حال بار گذاری"}
                    />
                  </div>
                )}
              </div>
              {hasNextPage && news.length > 0 ? (
                <button
                  id={styles.nextPageButton}
                  className={nextPageLoading ? styles.disabledLoader : null}
                  onClick={!nextPageLoading ? getNextPage : null}
                >
                  {nextPageLoading ? (
                    "..."
                  ) : (
                    <i className={"fa fa-arrow-down"}></i>
                  )}
                </button>
              ) : null}
            </div>
            <div className={"col-xs-12 col-md-3 pull-left"}>
              <div id={styles.sideBarContent}>
                {attachments && attachments.length > 0
                  ? attachments.map((item, index) => (
                      <div
                        className={"siderbar-elems"}
                        key={index + "-attachments-sidebar"}
                      >
                        <Heading title={item.title}></Heading>
                        <a
                          rel={"noreferrer"}
                          target="_blank"
                          href={item.destination_url}
                        >
                          <img
                            src={item.attachment_files[0].server_relative_url}
                            alt={item.title}
                            className={"image-responsive"}
                          />
                        </a>
                      </div>
                    ))
                  : null}
              </div>
            </div>
            <div className={"clearfix"}></div>
          </div>
          <div className={"clearfix"}></div>
        </div>
      </div>
    </>
  );
};

export default NewsList;
